<template>
	<div>
		<v-navigation-drawer v-model="dialog" class="elevation-0" width="420" fixed right temporary stateless>
			<v-card elevation="0">
				<v-card-title>
					授权记录<v-spacer />
					<v-btn class="mx-0" icon @click="(dialog = false), (dialogPath = false)"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider />
				<v-list-item class="py-1">
					<v-list-item-avatar size="56" color="blue-grey lighten-5">
						<v-icon color="blue" size="36">mdi-poker-chip</v-icon>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title class="font-weight-bold mb-2">{{ recordView.name }}</v-list-item-title>
						<v-list-item-subtitle class="caption">{{ recordView.note }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-divider />
				<v-card-text class="grey--text" :class="examList[0]?.state == 1 && 'serve_yhd'">
					<p class="mb-2">
						申请单位：<span class="blue-grey--text">{{ user.uniName }}</span>
					</p>
					<p class="mb-2">
						信用证号：<span class="blue-grey--text">{{ user.uniCode }}</span>
					</p>
					<p class="mb-2">
						申请区域：<span class="blue-grey--text">{{ examList[0]?.area }}</span>
					</p>
					<p class="mb-2">
						有效期限：<span class="blue-grey--text">{{ examList[0]?.btime | date("yyyy-MM-dd") }} ~ {{ examList[0]?.etime | date("yyyy-MM-dd") }}</span>
					</p>
					<p class="mb-0">每日用量：{{ examList[0]?.nums }}</p>
				</v-card-text>
				<v-divider />
				<v-timeline v-if="examList.length > 0" dense>
					<v-timeline-item v-for="(item, index) in examList" :key="index" color="blue" small class="elevation-0">
						<div @click="toPath(item)">
							<h4 class="font-weight-medium">
								{{ item.name }}
								<v-chip v-if="item.name == '审核'" :color="item.state | dict('0:red/1:green')" class="white--text px-2 ml-1" style="height: 20px" small label> {{ item.state | dict("0:不通过/1:通过") }} </v-chip>
								<span class="float-right grey--text caption mr-4">{{ item.operateTime | date("yyyy-MM-dd HH:mm:ss") }}</span>
							</h4>
							<p class="blue-grey--text caption mt-1 mb-1 pr-3">操作人员：{{ item.operator }}</p>
							<p class="blue-grey--text caption mb-1 pr-3">有效期限：{{ item.btime | date("yyyy-MM-dd") }} ~ {{ item.etime | date("yyyy-MM-dd") }}</p>
							<p class="blue-grey--text caption mb-1 pr-3">每日用量：{{ item.nums }}</p>
							<!-- <p class="blue-grey--text caption mb-0 pr-3">备注说明：{{ item.stateNote }}</p> -->
						</div>
					</v-timeline-item>
				</v-timeline>
			</v-card>
		</v-navigation-drawer>
		<v-navigation-drawer v-model="dialogPath" width="420" fixed right style="right: 420px; z-index: 8">
			<v-card elevation="0">
				<v-card-title>
					审核记录<v-spacer />
					<v-btn class="mx-0" icon @click="dialogPath = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider />
				<v-timeline v-if="examList.length > 0" dense>
					<v-timeline-item v-for="(item, index) in pathList" :key="index" color="blue" small class="elevation-0">
						<div>
							<h4 class="font-weight-medium">
								{{ item.name }}
								<v-chip v-if="item.name == '审核'" :color="item.state | dict('0:red/1:green')" class="white--text px-2 ml-1" style="height: 20px" small label> {{ item.state | dict("0:不通过/1:通过") }} </v-chip>
								<span class="float-right grey--text caption mr-4">{{ item.operateTime | date("yyyy-MM-dd HH:mm:ss") }}</span>
							</h4>
							<p class="blue-grey--text caption mt-1 mb-1 pr-3">操作人员：{{ item.operator }}</p>
							<p class="blue-grey--text caption mb-0 pr-3">备注说明：{{ item.stateNote }}</p>
						</div>
					</v-timeline-item>
				</v-timeline>
			</v-card>
		</v-navigation-drawer>
	</div>
</template>

<script>
import Request from "@/commons/request";
export default {
	data() {
		return {
			user: {},
			dialog: false,
			recordView: {},
			examList: [],
			dialogPath: false,
			pathList: [],
		};
	},
	mounted() {},
	methods: {
		view(item) {
			this.user = this.$vtk.storage.get("_wit_acis_users");
			console.log(item);
			this.recordView = item;
			Request.postJson("/app/apis/regs", { codex: { acid: this.user.acid, apis: item.id } }).then((res) => {
				if (res.meta.success) {
					this.dialog = true;
					this.examList = res.data;
					this.examList.sort((a, b) => {
						return new Date(b.date) - new Date(a.date);
					});
				}
			});
		},
		toPath(item) {
			if (item?.stateJson == "[]") {
				this.$vtk.message.toast("当前授权记录暂无流程信息！", { color: " error " });
				return;
			}
			this.pathList = JSON.parse(item.stateJson);
			this.dialogPath = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.serve_yhd {
	background: url(../../assets/img/yhd.png) no-repeat;
	background-size: 88px;
	background-position: calc(100% + 12px) calc(100% + 18px);
}
</style>
